import { PresenceAvatars } from 'common/PresenceAvatars/PresenceAvatars'
import { useContext } from 'react'
import { DocPresenceContext } from 'stores/DocPresence'
import { PresenceUser, UsersMetadata } from 'types'
import Styles from './PresenceOutOfView.module.scss'

export const PresenceOutOfView = ({
  users,
  metadata,
  direction,
}: {
  users: PresenceUser[]
  metadata: UsersMetadata
  direction: 'top' | 'bottom'
}) => {
  const docPresence = useContext(DocPresenceContext)
  return (
    <>
      {!!users.length && (
        <div className={Styles.presenceOutOfViewContainer}>
          <div className={Styles.directionAndAvatars}>
            {direction === 'top' && <div className={Styles.directionArrow}>↑</div>}
            {direction === 'bottom' && <div className={Styles.directionArrow}>↓</div>}
            <PresenceAvatars
              metadata={metadata}
              users={users}
              showMinCount={0}
              showMaxCount={2}
              docPresence={docPresence}
            />
          </div>
        </div>
      )}
    </>
  )
}
